import { render, staticRenderFns } from "./AdminSidemenuLayout.vue?vue&type=template&id=3543103e&scoped=true&lang=pug&"
import script from "./AdminSidemenuLayout.vue?vue&type=script&lang=ts&"
export * from "./AdminSidemenuLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3543103e",
  null
  
)

export default component.exports